module.exports = __webpack_public_path__ + "static/media/edit.34f90076.svg";